import React from "react"
import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

import ResultImageGroup from "../resultsimage/resultsimagegroup"

import { Name, ProductText, TagsContainer, Tag } from "./resultscard.styled"

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const ImageWrapper = styled.div`
  margin-bottom: 8px;
`

const ResultsInfoWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 16px;
  flex-direction: column;
  border-radius: 8px;
  padding: 16px;

  @media (min-width: ${theme.mediaqueries.small}) {
    padding: 42px 16px;
    text-align: center;
    align-items: center;
  }
`

const ResultsCard = ({
  afterImage,
  beforeImage,
  imageDirection = "center",
  after,
  name,
  product,
  tags,
  action,
  badgePosition = "bottom-left",
  showDisclaimer = true,
}) => {
  const resultImageData = {
    badgePosition,
    imageDirection,
    before: {
      image: beforeImage,
      label: "Before",
      alt: `${name} before ${action.toLowerCase()} ${product}.`,
      role: "presentation",
    },
    after: {
      image: afterImage,
      label: `${after} months growing`,
      alt: `${name} ${after} months into ${action.toLowerCase()} ${product}. Results are from a clinical study and may vary`,
      role: "presentation",
    },
  }

  return (
    <CardWrapper>
      <ImageWrapper>
        <ResultImageGroup {...resultImageData} />
      </ImageWrapper>
      <ResultsInfoWrapper>
        {name ? <Name element="h3" text={name} className="" /> : null}
        {product ? (
          <Box maxWidth={350}>
            <ProductText
              className=""
              text={`${action} <strong>${product}</strong>`}
            />
          </Box>
        ) : null}
        {tags ? (
          <TagsContainer justifyContent={[null, null, "center"]}>
            {tags?.map((tag) => (
              <Tag key={tag} text={tag} className="" />
            ))}
          </TagsContainer>
        ) : null}
      </ResultsInfoWrapper>
    </CardWrapper>
  )
}

export default ResultsCard
